// import { disablePageScroll, enablePageScroll, addLockableTarget } from 'scroll-lock';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { mapActions } from 'vuex'

export const mvCommonMixin = {
    data() {
        return {}
    },
    methods: {
        ...mapActions([
            'setPageLock'
        ]),
        changeCebnfkd(type) {
            if (type === "1") {
                return "年金";
            } else if (type === "2") {
                return "滿期";
            } else if (type === "3") {
                return "身故";
            } else if (type === "4") {
                return "祝壽";
            } else if (type === "5") {
                return "配特身故";
            } else if (type === "D") {
                return "身故(妻)";
            } else if (type === "E") {
                return "祝壽(妻)";
            }
        },
        getChMoneyUnit(type) {
            if (type === "AUD") {
                return "澳幣";
            } else if (type === "CNY") {
                return "人民幣";
            } else if (type === "EUR") {
                return "歐元";
            } else if (type === "GBP") {
                return "英鎊";
            } else if (type === "HKD") {
                return "港幣";
            } else if (type === "JPY") {
                return "日幣";
            } else if (type === "NZD") {
                return "紐幣";
            } else if (type === "NTD") {
                return "台幣";
            } else if (type === "USD") {
                return "美元";
            } else if (type === "ZAR") {
                return "南非幣";
            }
        },
        getUnit(unit) {
            if (1 === unit) {
                return "元"
            } else if (2 === unit) {
                return "萬"
            } else if (3 === unit) {
                return "單位"
            }
        },
        getCepremamt(infcd, isPrimaryContract) {
            if ("0" === infcd || "00" === infcd) {
                if (isPrimaryContract == true) {
                    return "正常";
                } else {
                    return "有效";
                }
            } else if ("02" === infcd || "36" === infcd) {
                return "滿期";
            } else if ("20" === infcd) {
                return "展期";
            } else if ("21" === infcd) {
                return "展期件滿期";
            } else if ("23" === infcd) {
                return "繳清";
            } else if ("24" === infcd) {
                return "繳清件滿期";
            } else if ("40" === infcd || "42" === infcd) {
                return "主被保人身故";
            } else if ("52" === infcd) {
                return "主被保人完全失能";
            } else if ("23" === infcd) {
                return "長期看護";
            } else if ("54" === infcd) {
                return "重大疾病";
            }
        }        
    },
    mounted() {}
}